<template>
  <v-row>
    <v-tabs
      v-model="newActiveTab"
      fixedTabs
      :class="`${massBalanceCustomStyle ? 'pHeader' : ''} AddAnalysis--blocTitles`"
    >
      <v-tab
        v-for="tab of tabs"
        :key="tab.index"
        :class="[`${customClass ? customClass : ''}`]"
        :disabled="tab.disabled"
        class="addAnalysis--blocTitles__title"
      >
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <div
      :class="`${massBalanceCustomStyle ? massBalanceCustomStyle : 'container'}`"
      :style="`${massBalanceCustomStyle ? massBalanceCustomStyle : 'padding: 30px;'} ${containerCustomStyle}`"
    >
      <v-tabs-items
        v-model="newActiveTab"
      >
        <v-tab-item
          v-for="tab of tabs"
          :key="'tab-item' + tab.index"
        >
          <component
            :is="tab.component"
            :value="$attrs.value"
            v-bind="{ ...tab.props }"
            v-on="$listeners"
            @inputChange="$emit('inputChange')"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-row>
</template>

<script>
export default {
    props: {
        activeTab: {
            type: Number,
            default: null,
        },
        tabs: {
            type: Array,
            default: () => [],
        },
        customClass: {
            type: String,
            default: null,
        },
        containerCustomStyle: {
            type: String,
            default: '',
        },
        massBalanceCustomStyle: {
            type: String,
            default: '',
        },
    },
    computed: {
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
    },
};
</script>
<style lang="scss">
.pHeader{
    padding: 0 1.5rem;
}
@media (max-width: 720px) {
  .addAnalysis--blocTitles {
    &__title {
      text-wrap: none;
      padding:0;
      min-width: 120px !important;
    }
    .v-slide-group__prev {
        display: none !important;
        width: 0 !important
      }
    }
    .modal-container {
      display: flex;
      flex-direction: column;
    }
}
</style>
